import { Footer as PageFooter } from '@web/components/page-components/Footer'
import { type Footer as FooterProps } from '@web/graphql-types'
import { usePageStore } from 'apps/fe-donation/libs/hooks/usePageStore'
import { useSearchParams } from 'next/navigation'
import { useMemo } from 'react'

const Footer = (props: FooterProps & { isFullWidth?: boolean }) => {
  const campaignDomain = usePageStore((state) => state.campaignDomain)
  const searchParams = useSearchParams()
  const links = useMemo(() => {
    if (!campaignDomain) {
      return []
    }

    const hasParams = !!searchParams?.toString()

    return props.styles?.links?.map((link) => {
      if (link.url.startsWith('http')) {
        return { ...link, url: `${link.url}${hasParams ? `?${searchParams!.toString()}` : ''}` }
      }

      return {
        ...link,
        url: `${campaignDomain}${link.url.startsWith('/') ? `${link.url}` : `/${link.url}`}${hasParams ? `?${searchParams!.toString()}` : ''}`,
      }
    })
  }, [campaignDomain])

  return <PageFooter {...props} styles={{ ...props.styles, links }} />
}

export default Footer
